// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest } from '@polkadot/x-rxjs';
import { switchMap } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
/**
 * @description Get the member info for a society
 */

export function members(instanceId, api) {
  return memo(instanceId, function () {
    return api.query.society.members().pipe(switchMap(function (members) {
      return combineLatest(members.map(function (accountId) {
        return api.derive.society.member(accountId);
      }));
    }));
  });
}